export const updateAriaLabels = (labels, labelID, baseID, sliderDOM, prefix = '', describedById) => {
    if (!(labels && sliderDOM))
        return;
    const sliderHandles = Array.from(sliderDOM.querySelectorAll(`.${prefix}slider-handle`));
    sliderHandles.forEach((handle, index) => {
        const handleId = `${baseID}__handle-${index}`;
        handle.id = handleId;
        handle.setAttribute('aria-label', labels[index]);
        handle.setAttribute('aria-labelledby', `${labelID} ${handleId}`);
        if (describedById)
            handle.setAttribute('aria-describedby', describedById);
    });
};
const styleNamePrefix = '--skapa-slider-handle-value-';
export const reflectHandleStyles = (values, range, sliderDOM, step = 1) => {
    if (!(values && range && sliderDOM))
        return;
    sliderDOM.style.setProperty('--skapa-slider-step-count', ((range.max - range.min) / step).toString());
    const valuesInpercent = values.map((value) => (100 * ((value - range.min) / (range.max - range.min))).toFixed(2));
    valuesInpercent.forEach((value, index) => sliderDOM.style.setProperty(styleNamePrefix + index, `${value}%`));
};
